module.exports = __webpack_public_path__ + "assets/img/tiyan4.a2f84bbb.png";